import { isLinkedLibrarySlide } from './librarySlides';
import { SlideObject, PresentationSlide } from './types';

export function isLibraryFollowSlide(
  slide?: { librarySlideId?: string | null; libraryDetached?: boolean } | null,
): boolean {
  return isLinkedLibrarySlide(slide);
}

export function objectHasProductLink(object?: SlideObject | null): boolean {
  if (!object) return false;
  if (object.fieldBinding) return true;
  if (object.linkedFrom) return true;
  if (object.slotId === 'product') return true;
  return object.type === 'product' && Boolean(object.slotId);
}

export function isProductLinkedSlide(
  slide?: Pick<PresentationSlide, 'objects'> | { objects?: SlideObject[] | null } | null,
): boolean {
  return (slide?.objects || []).some((object) => objectHasProductLink(object));
}
